function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0-1.032A6.968 6.968 0 015.032 12 6.968 6.968 0 0112 5.032 6.968 6.968 0 0118.968 12 6.968 6.968 0 0112 18.968zm-1.253-3.095l5.822-5.775a.388.388 0 00.002-.547l-.273-.275a.386.386 0 00-.547-.002l-5.272 5.23-2.225-2.243a.388.388 0 00-.548-.003l-.275.273a.388.388 0 00-.002.547l2.77 2.793c.15.152.396.153.548.002z",
  fill: "#212121",
  fillRule: "nonzero"
});

function SvgCheckCircleinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgCheckCircleinline;